/**
 * product-card.js
 * Delegated click/keyboard handler for the size pills rendered by
 * snippets/product-card.liquid (one listener for the whole grid,
 * regardless of how many cards are on the page). Purely visual
 * single-select per card; hook into your quick-add / cart logic
 * by listening for the "size-pill:selected" custom event below.
 */
(function () {
  function selectPill(pill) {
    if (!pill || pill.classList.contains('size-pill--disabled')) return;

    var group = pill.closest('.product-card__sizes');
    if (!group) return;

    group.querySelectorAll('.size-pill.is-selected').forEach(function (el) {
      el.classList.remove('is-selected');
    });
    pill.classList.add('is-selected');

    var card = pill.closest('.product-card');
    pill.dispatchEvent(
      new CustomEvent('size-pill:selected', {
        bubbles: true,
        detail: {
          size: pill.textContent.trim(),
          productId: card ? card.getAttribute('data-product-id') : null,
        },
      })
    );
  }

  document.addEventListener('click', function (event) {
    var pill = event.target.closest('[data-size-pill]');
    if (pill) selectPill(pill);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var pill = event.target.closest('[data-size-pill]');
    if (pill) {
      event.preventDefault();
      selectPill(pill);
    }
  });
})();
